import { render, staticRenderFns } from "./productItem2.vue?vue&type=template&id=06669897&scoped=true&"
import script from "./productItem2.vue?vue&type=script&lang=js&"
export * from "./productItem2.vue?vue&type=script&lang=js&"
import style0 from "./productItem2.vue?vue&type=style&index=0&id=06669897&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06669897",
  null
  
)

export default component.exports